import AlreadyAdminView from './AlreadyAdminView';
import ErrorView from './ErrorView';
import SuccessView from './SuccessView';
import Form from './Form';

const Stages = {
  AlreadyAdminView,
  ErrorView,
  Form,
  SuccessView,
};

export default Stages;
